import { render } from "./DisclaimerCard.vue?vue&type=template&id=feed8c12&scoped=true"
const script = {}

import "./DisclaimerCard.vue?vue&type=style&index=0&id=feed8c12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feed8c12"]])

export default __exports__